import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmoji } from '../../../../store/slices/emojiSlice';
import { Button } from 'antd';
import EmojiForm from './form';
import { LoadingOutlined } from '@ant-design/icons';

const Emoji = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const emoji = useSelector((state) => state.emoji);

  useEffect(() => {
    dispatch(fetchEmoji());
  }, [showForm]);

  return (
    <div className="flex justify-between ">
      {emoji?.isLoading ? (
        <div>
          <LoadingOutlined />
        </div>
      ) : showForm ? (
        <div>
          <EmojiForm setShowForm={setShowForm} />
        </div>
      ) : (
        <div className="flex w-full justify-between items-center">
          <div className="flex space-x-2 items-center">
            {emoji?.response?.emoji ? (
              <div className='flex space-x-2 items-center'>
                <p className="text-[16px]">Current Emoji:</p>
                <p className="text-[20px]">{emoji?.response?.emoji}</p>
              </div>
            ) : (
              <div className='px-2 border border-solid border-black w-full flex items-center justify-center'>
                <p className='w-full'>You don't have any Emojies set up right now</p>
              </div>
            )}
          </div>
        </div>
      )}
      <Button
        onClick={() => {
          setShowForm(!showForm);
        }}
      >
        {showForm
          ? 'Cancel'
          : `${emoji?.response?.emoji ? 'Update Emoji' : 'Add Emoji'}`}
      </Button>
    </div>
  );
};

export default Emoji;
